export const ElationPatient = '/api/v1/elation-patient'
export const ElationPatientCreateAccount = `${ElationPatient}/create-account`
